import config from '../../authentication/config';

export const getTokenFromMessage = value => {
    const token =
        value.token ??
        `jwt=${value?.jwtToken}&version=${value?.version}&client_id=${config.getClientId()}&response-type=token`;

    return token;
};
